// =============================================================================
// halo-toolcart.js
// =============================================================================

// ────────────────────────────────────────────────────────────────
// cart-item-tool: handles opening tool popups (note, gift, shipping, discount)
// ────────────────────────────────────────────────────────────────
class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      });
    });
  }
}
customElements.define('cart-item-tool', CartTool);

// ────────────────────────────────────────────────────────────────
// cart-cancel-popup: handles closing any open popup-toolDown
// ────────────────────────────────────────────────────────────────
class CartCancel extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button').addEventListener('click', (event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    });
  }
}
customElements.define('cart-cancel-popup', CartCancel);

// ────────────────────────────────────────────────────────────────
// cart-note: handles the “Save” in the popup note (legacy popup)
// ────────────────────────────────────────────────────────────────
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    });
  }
}
customElements.define('cart-note', CartNote);

// ────────────────────────────────────────────────────────────────
// coupon-code: handles “Apply” in the coupon popup
// ────────────────────────────────────────────────────────────────
class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')) {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
        .then((response) => response.text())
        .then((responseText) => {
          // no-op
        });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
      Shopify.getCart((cart) => { window.sharedFunctions?.updateSidebarCart(cart); });
    });
  }
}
customElements.define('coupon-code', CouponCode);

// ────────────────────────────────────────────────────────────────
// Auto‐saved “is-saved” state for the Cart Note Save button
// — turns button gray when saved, re-enables on edit
// ────────────────────────────────────────────────────────────────
;(function() {
  var SAVE_BTN_SELECTOR = '[data-update-note]';
  var TEXTAREA_SELECTOR = '#Cart-note';

  // On Save button click…
  document.body.addEventListener('click', function(e) {
    if (!e.target.matches(SAVE_BTN_SELECTOR)) return;
    e.preventDefault();

    var btn = e.target;
    var textarea = document.querySelector(TEXTAREA_SELECTOR);
    if (!textarea) return;

    btn.disabled = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: textarea.value })
    })
    .then(function() {
      // mark saved (gray)
      btn.classList.add('is-saved');
    })
    .catch(function() {
      // revert on error
      btn.disabled = false;
      btn.classList.remove('is-saved');
    });
  });

  // Clear saved state when user types again
  document.body.addEventListener('input', function(e) {
    if (!e.target.matches(TEXTAREA_SELECTOR)) return;
    var btn = document.querySelector(SAVE_BTN_SELECTOR);
    if (!btn) return;
    btn.classList.remove('is-saved');
    btn.disabled = false;
  });
})();

// ────────────────────────────────────────────────────────────────
// “Intact Personalize your order” accordion toggle handler
// — opens/closes the inline note section in the side cart
// ────────────────────────────────────────────────────────────────
;(function() {
  document.body.addEventListener('click', function(e) {
    // Toggle open/close
    var toggle = e.target.closest('.personalize-toggle');
    if (toggle) {
      var container = toggle.closest('.previewCart-personalize');
      var content   = container.querySelector('.personalize-content');
      var chevron   = container.querySelector('.chevron-icon');

      content.classList.toggle('open');
      chevron.classList.toggle('open');
      chevron.style.transform = chevron.classList.contains('open')
        ? 'rotate(180deg)'
        : 'rotate(0)';
    }

    // Support explicit “Cancel” if you still have one
    if (e.target.matches('[data-close-note]')) {
      var parent = e.target.closest('.previewCart-personalize');
      parent.querySelector('.personalize-content').classList.remove('open');
      parent.querySelector('.chevron-icon').style.transform = 'rotate(0)';
    }
  });
})();


// ─────Intact Variant dropdown sheet inside side-cart ─────
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    //
    // 1) Toggle open/closed
    //
    const toggle = e.target.closest('.variant-toggle');
    if (toggle) {
      const wrapper = toggle.closest('.variant-dropdown-wrapper');
      const opts    = wrapper.querySelector('.variant-options');
      opts.hidden = !opts.hidden;
      wrapper.classList.toggle('open', !opts.hidden);
      return; // stop here when we're just opening/closing
    }
    
    //
    // 2) User picked a size
    //
    const opt = e.target.closest('.variant-option');
    if (!opt) return;
    
    const wrapper   = opt.closest('.variant-dropdown-wrapper');
    const btn       = wrapper.querySelector('.variant-toggle .variant-current');
    const optsCont  = wrapper.querySelector('.variant-options');
    const newTitle  = opt.textContent.trim();
    const line      = parseInt(opt.dataset.line, 10);
    const vid       = parseInt(opt.dataset.variantId, 10);
    const qtyInput  = wrapper
      .closest('li.previewCartItem')
      .querySelector('input.quantity');
    const qty       = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    
    // 3) AJAX swap (remove old line, then add new one)
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ line, quantity: 0 })
    })
    .then(() =>
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ id: vid, quantity: qty })
      })
    )
    .then(r => r.json())
    .then(cart => {
      // update label and close dropdown
      btn.textContent = newTitle;
      optsCont.hidden = true;
      wrapper.classList.remove('open');
      // re-render sidebar totals & counts
      window.sharedFunctions?.updateSidebarCart(cart);
    })
    .catch(console.error);
  });
});
